import axios from 'axios';
import { getToken } from '../oidc/AuthService';
// export function getCallWithoutReducer(url, inputJson, onSuccess, onFailure, e, blockerType) {
//     return function (dispatch) {
//       if(blockerType === null){
//         dispatch(setBlockingState(true));
//       }else{
//         dispatch(setDivBlockingState(true));
//       }
//       axios.get(url, {
//         params: inputJson,
//         headers:{
//           'Content-type': 'application/json',
//           'Accept': 'application/json',
//           'Authorization': 'Bearer ' + getToken()
//         }
//       })
//         .then((response) => {
//           if(blockerType === null){
//             dispatch(setBlockingState(false));
//           }else{
//             dispatch(setDivBlockingState(false));
//           }
//           if (response.status === 200) {
//             if (onSuccess) {  
//               if (response !== null && typeof response ==='object') {
//                 const data = commonFunction.safeAccess(response, 'data', {});  
//                 if(e){
//                   onSuccess(e,data)
//                 } else {
//                   onSuccess(data)
//                 }
//               }
//             }
//           } else if(response.status === 503 || response.status === 505){
//             maintainencePage()
//           }
//           else {
//             //for other codes
//             if (onSuccess) {
//                e ? onSuccess(e, response) : onSuccess(response) ;
//             }
//           }
//         })
//         .catch((err) => {
//           if(blockerType === null){
//             dispatch(setBlockingState(false));
//           }else{
//             dispatch(setDivBlockingState(false));
//           }
//           if (onFailure) {
//              e ? onFailure(err, e) : onFailure(err) ;
//           }
//         })
//     }
//   }

  // export function postCallWithoutReducer(url, inputJson, onSuccess, onFailure, e, params , projectTaskId) {
  //   return function (dispatch) {
  //     dispatch(setBlockingState(true));
  //     axios.post(url, inputJson, {
  //       params:params,
  //       headers: projectTaskId?{
  //         'Content-Type': CONTENT_TYPE,
  //         'Accept': CONTENT_TYPE,
  //         'Authorization': 'Bearer ' + getToken(),
  //         'Project-Task-Id':projectTaskId
  //       }:{
  //         'Content-Type': CONTENT_TYPE,
  //         'Accept': CONTENT_TYPE,
  //         'Authorization': 'Bearer ' + getToken()
  //       }
  //     })
  //       .then((response) => {
  //         dispatch(setBlockingState(false));
  //         if (response.status === 200 || response.status === 201) {
  //           if (onSuccess) {
  //             if (response !== null && typeof response ==='object') {
  //               const data = commonFunction.safeAccess(response, 'data', {});  
  //               if(e){
  //                 onSuccess(e,data)
  //               } else {
  //                 onSuccess(data)
  //               }
  //             }
  //           }
  //         }else if(response.status === 503 || response.status === 505){
  //           maintainencePage()
  //         }
  //       })
  //       .catch((err) => {
  //         dispatch(setBlockingState(false));
  //         if (err.response ) {
  //            e ? onFailure(e, err.response) : onFailure(err.response) ;
  //         } else {
  //           let dummyResponseObject={
  //             "data":{
  //               "message":"Error while updating data.Please contact system administrator."
  //             }
  //           }
  //           e? onFailure(e,dummyResponseObject):onFailure(dummyResponseObject);
  //         }
  //       })
  //   }
  // }
  
//new code 
  export function getCallWithReducer(url,inputJson,reducerType) {
    return function (dispatch) {
      axios.get(url, {
        params: inputJson,
        headers:{
          'Content-type': 'application/json',
          'Accept': 'application/json',
          'X-Frame-Options':'DENY',
          'Authorization': 'Bearer ' + getToken()
        }
      })
        .then(response => {
          dispatch({
            type: reducerType,
            payload: response.data
          });
        })
        .catch(function (error) {
          if (error && error.status && (error.status === 429)) {
          } else {
            console.error(error);
          }
        })
    }
  }

  

  export function postCallWithReducer(URL,Dto,reducerType) {
    return function (dispatch) {
      axios
        .post(URL, Dto, {
          headers: {
            "Content-type": "application/json",
              'Accept': "application/json",
              'Pragma': "no-cache",
              'X-Frame-Options':'DENY',
            'Authorization': 'Bearer ' + getToken()
          }
        })
        .then(response => {
          //dispatch(setBlockingState(false));
          dispatch({
            type: reducerType,
            payload: response.data
          });
        })
        .catch(function (error) {
          if (error && error.status && (error.status === 429)) {
          } else {
            console.error(error);
          }
        });
    };
  }

export function fetchWithAuthentication(url) {
  const headers = new Headers();
  const authToken = getToken();
  headers.set('Authorization', `Bearer ${authToken}`);
  headers.set('Accept', 'application/json');
  
  return fetch(url, { 
    headers,
    method: 'GET'
  });
}
export function arrayBufferToBase64(buffer) {
  let binary = '';
  let bytes = [].slice.call(new Uint8Array(buffer));
  bytes.forEach((b) => binary += String.fromCharCode(b));
  return window.btoa(binary);
};
export async function displayProtectedImage(imageUrl) {
  try {
    console.log('🖼️ Loading protected image:', imageUrl);
    
    // Fetch the image.
    const response = await fetchWithAuthentication(imageUrl);
    
    if (!response.ok) {
      throw new Error(`HTTP error! status: ${response.status}`);
    }
    
    console.log('✅ Image fetch successful, response status:', response.status);

    //  const binaryData = await response.arrayBuffer();
    // const base64 = arrayBufferToBase64(binaryData);
    // const dataUrl = `data:image/png;base64,${base64}`;

    //Create an object URL from the data.
    const blob = await response.blob();
    console.log('✅ Blob created, size:', blob.size, 'type:', blob.type);
    
    const objectUrl = URL.createObjectURL(blob);
    console.log('✅ Object URL created:', objectUrl);
    
    return objectUrl;
  } catch (error) {
    console.error('❌ Error loading protected image:', error);
    console.error('Failed URL:', imageUrl);
    // Return a fallback or placeholder image URL
    return null;
  }
}

// Add a synchronous helper function that returns a Promise for immediate use
export function getProtectedImageUrl(imageUrl) {
  return displayProtectedImage(imageUrl);
}

// React-friendly function that can be used with useState/useEffect
export function loadProtectedImage(imageUrl, callback) {
  displayProtectedImage(imageUrl)
    .then(objectUrl => {
      if (callback) callback(objectUrl);
    })
    .catch(error => {
      console.error('Error loading protected image:', error);
      if (callback) callback(null);
    });
}
